import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { SettingsContext } from "../../contexts";
import { Bubble } from "../../core/components";

const defaultActiveFn = (pathname, tab, tabs) =>
  typeof tab.active === "undefined" && pathname.indexOf(tab.link) === 0;

const Tabs = ({
  tabs,
  mobile = false,
  desktop = false,
  className = "",
  activeFn = defaultActiveFn,
  priceCount = 0,
  tabClass,
}) => {
  const [newPriceCount, setNewPriceCount] = useState(priceCount);
  const settings = useContext(SettingsContext);
  const { pathname } = useLocation();

  useEffect(() => {
    setNewPriceCount(priceCount);
  }, [priceCount]);

  let rootClasses = `layout-tabs ${className} ${
    tabs.length > 2 ? "two-rows" : ""
  }`;
  if (mobile) {
    rootClasses += " mobile";
  }
  if (desktop) {
    rootClasses += " desktop";
  }

  return (
    <div className={rootClasses}>
      <div className="tabs-container container">
        {tabs.map((tab) => {
          const active = tab.active || activeFn(pathname, tab, tabs);

          return (
            <div
              key={tab.label}
              className={`tab ${active ? "active" : ""} tabs-${tabs.length}`}
            >
              <Link
                className={tabClass ? "large-tab" : ""}
                to={tab.link + `?${settings.iframeQueryParams}`}
              >
                {tab.label}
              </Link>

              <Bubble
                where="order-header"
                priceCount={active ? newPriceCount : 0}
              />

              <div className="bottom-border" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
